import React, { useCallback, useState } from "react";
import { Button, Fade, Modal, Backdrop } from "@material-ui/core";
import CloseIcon from "../../../assets/svgs/closeIcon.svg";
import { injected } from "../../../utils/web3Connectors";
import MetamaskLogo from "../../../assets/images/MetamaskLogo.png";
import useStyles from "./transactionModalStyles";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";


function TransactionModal({children, open, handleClose, height, width, claimTokensModal }) {
  // height:claimTokensModal?height:(claimTokensModal?height:"260px")
  // const classes = useStyles({height:height?height:"300px", width:width?width:"325px"});
  const classes = useStyles({height:height?height:"300px", width:width?width:"325px"});
  const [changeModalOpen, setChangeModalOpen] = useState(false);
  const [changeOpen, setChangeOpen] = useState(false);
  const { account, active, connector, deactivate, library, chainId } =
    useWeb3React();

    const handleChangeWallet = () => {
        setChangeModalOpen(true);
      };

      const handleChangeOpen = () => {
        setChangeOpen(true);
      };
    
      const handleChangeClose = () => {
        setChangeOpen(false);
      };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            {children}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default TransactionModal;
